import createLogger from 'vuex/dist/logger'

export default ({ store }) => {
  createLogger()(store)
}



// WEBPACK FOOTER //
// ./src/modules/logger/index.js